import React from 'react';
import SectionCard from './SectionCard';
import { Checkbox } from '../../ui/checkbox';

const MeetingSection = ({ submission, jsonContent, isDark }) => {
    if (submission.recipient_source === 'non-strata' || (!submission.meetingRegisterID && !submission.skip_meeting_update)) {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <span className={`font-medium text-[16px] leading-normal transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Meeting</span>
            
            {(submission.meetingName || jsonContent.meetingName) && (
                <div className={`border-none rounded-[8px] p-[12px] flex items-center justify-between relative w-full transition-colors duration-200 ${
                    isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
                }`}>
                    <input
                        className={`grow basis-0 min-w-0 font-normal text-[16px] bg-transparent border-0 outline-none transition-colors duration-200 ${
                            isDark ? 'text-white' : 'text-[#686868]'
                        }`}
                        type="text"
                        value={submission.meetingName || jsonContent.meetingName || ''}
                        readOnly
                    />
                </div>
            )}
            
            {(submission.online_voting_open_for_voting === true || submission.online_voting_open_for_voting === false ||
              submission.online_voting_show_on_portal === true || submission.online_voting_show_on_portal === false) ? (
                <>
                    <label className={`inline-flex items-center gap-[8px] text-[14px] font-normal transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>
                        <Checkbox
                            id="online-voting-open-for-voting"
                            checked={submission.online_voting_open_for_voting === true}
                            labelClassName="cursor-default"
                            isDark={isDark}
                        />
                        <span>Open for Online Voting</span>
                    </label>
                    <label className={`inline-flex items-center gap-[8px] text-[14px] font-normal transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>
                        <Checkbox
                            id="online-voting-show-on-portal"
                            checked={submission.online_voting_show_on_portal === true}
                            labelClassName="cursor-default"
                            isDark={isDark}
                        />
                        <span>Show on Portal</span>
                    </label>
                </>
            ) : (
                <label className={`inline-flex items-center gap-[8px] text-[16px] font-normal transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>
                    <Checkbox
                        id="skip-meeting-update"
                        checked={submission.skip_meeting_update}
                        labelClassName="cursor-default"
                        isDark={isDark}
                    />
                    <span>Skip as my meeting is already updated in Strata Master</span>
                </label>
            )}
        </SectionCard>
    );
};

export default MeetingSection;
